// extracted by mini-css-extract-plugin
export default {"container":"Login_container__dYpJf","card":"Login_card__-OPX5","header":"Login_header__EJGeN","content":"Login_content__cHJYn","btnSubmit":"Login_btnSubmit__OtPyL"};